import etZoneDataConfig from '@/api/config/etZoneDataConfig'
import { queryKeys } from '@/constant/common'
import { EtZone } from '@/types'
import { APIResponseList, SearchParams } from '@/types/common'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchEtZone(
  interfaceId: any,
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<EtZone>, any> {
  return useQuery(
    [queryKeys.etZone, interfaceId, searchParams],
    async () => {
      const { data } = await etZoneDataConfig.getAll(interfaceId.toString(), {
        ...searchParams,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchEtZone
